<template>
    <ManualSection :header="header" :open="open" @click="$emit('click')" :state="isUserContactDataFilled ? 'success' : 'danger'">
        <UserContact :show-header="false" :small-edit-button="true" />
        <template v-slot:comment v-if="isUserContactDataFilled && !open">
            <p v-for="str in userContactDataStrings" class="dataPreview cmnt" :key="str">{{ str }}</p>
        </template>
    </ManualSection>
</template>

<script>
import UserContact from '@/components/UserContact.vue'
import ManualSection from '@/components/ManualSection.vue'

export default {
    props: {
        header: String,
        open: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ManualSection,
        UserContact,
    },
    computed: {
        isUserContactDataFilled() {
            return this.$store.getters.isUserContactDataFilled
        },
        userContactDataStrings() {
            return this.$store.getters.userContactDataStrings;
        }
    }
}
</script>
